/**
 * @flow weak
 */

export const UPDATE_PROGRESS_STEP = 'UPDATE_PROGRESS_STEP';
export const UPDATE_CREATE_FIELD = 'UPDATE_CREATE_FIELD';
export const UPDATE_LOCATION = 'UPDATE_LOCATION';
export const UPDATE_CURRENCY = 'UPDATE_CURRENCY';
export const GET_LOCATION_OPTIONS = 'GET_LOCATION_OPTIONS';
export const UPDATE_PROGRESS_STATUS = 'UPDATE_PROGRESS_STATUS';
export const VALIDATE_CREATE_FORM = 'VALIDATE_CREATE_FORM';
export const SET_EVENT_TYPE = 'SET_EVENT_TYPE';
export const QUESTIONNAIRE_STEP = 'QUESTIONNAIRE_STEP';
export const BASICS_STEP = 'BASICS_STEP';
export const WHEN_AND_WHERE_STEP = 'WHEN_AND_WHERE_STEP';
export const TICKETS_STEP = 'TICKETS_STEP';
export const SET_SOCIAL_IMAGE = 'SET_SOCIAL_IMAGE';
export const SET_COVER_IMAGE = 'SET_COVER_IMAGE';
export const CLEAR_COVER_IMAGE = 'CLEAR_COVER_IMAGE';
export const CLEAR_SOCIAL_IMAGE = 'CLEAR_SOCIAL_IMAGE';

export const updateStep = (nextStep: string) => {
  return {
    type: UPDATE_PROGRESS_STEP,
    payload: {
      nextStep
    }
  };
};

export const setEventType  = (type: string) => {
  return {
    type: SET_EVENT_TYPE,
    payload: {
      type
    }
  };
};

export const setSocialImage  = (image: Object, url: string) => {
  return {
    type: SET_SOCIAL_IMAGE,
    payload: {
      image,
      url
    }
  };
};

export const setCoverImage  = (image: Object, url: string) => {
  return {
    type: SET_COVER_IMAGE,
    payload: {
      image,
      url
    }
  };
};

export const clearCoverImage  = () => {
  return {
    type: CLEAR_COVER_IMAGE
  };
};

export const clearSocialImage  = () => {
  return {
    type: CLEAR_SOCIAL_IMAGE
  };
};

export const updateInput = (input: string, value: string) => {
  return {
    type: UPDATE_CREATE_FIELD,
    payload: {
      input,
      value
    }
  };
};

export const updateProgressStatus = (value: Object) => {
  return {
    type: UPDATE_PROGRESS_STATUS,
    payload: value
  };
};

export const updateLocation = (eventAddress: string, eventLatitude: number, eventLongitude: number) => {
  return {
    type: UPDATE_LOCATION,
    payload: {
      eventAddress,
      eventLatitude,
      eventLongitude
    }
  };
};

export const updateCurrency = (displayCurrency: string, transactedCurrency: string) => {
  return {
    type: UPDATE_CURRENCY,
    payload: {
      displayCurrency,
      transactedCurrency
    }
  };
};

export const validateForm = (page: string) => {
  return {
    type: VALIDATE_CREATE_FORM,
    payload: {
      page
    }
  };
};



// WEBPACK FOOTER //
// ./src/modules/create/actions.js